"use client";

import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";
import {
  ANDROID_PLAY_STORE_URL,
  IOS_APP_STORE_URL,
  buildMobileAppDeepLink,
} from "@/modules/app/links";

const DISMISSED_KEY = "smart_app_banner_dismissed";

function isMobileBrowser(): boolean {
  if (typeof window === "undefined") return false;
  // Don't show inside Electron
  if (navigator.userAgent.includes("Electron")) return false;
  // Check for mobile user agent
  return /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(
    navigator.userAgent,
  );
}

function isIOS(): boolean {
  if (typeof navigator === "undefined") return false;
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
}

export function SmartAppBanner() {
  const pathname = usePathname();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!isMobileBrowser()) return;
    if (pathname !== "/chats" && pathname !== "/chats/") return;
    if (localStorage.getItem(DISMISSED_KEY)) return;
    setVisible(true);
  }, [pathname]);

  if (!visible) return null;

  const dismiss = () => {
    localStorage.setItem(DISMISSED_KEY, "1");
    setVisible(false);
  };

  const openApp = () => {
    const storeUrl = isIOS() ? IOS_APP_STORE_URL : ANDROID_PLAY_STORE_URL;
    // Try deep link first; if it doesn't open after a short delay, go to store
    const start = Date.now();
    window.location.href = buildMobileAppDeepLink("/");

    setTimeout(() => {
      // If the page is still visible after 1.5s, deep link didn't work
      if (document.visibilityState === "visible" && Date.now() - start < 2000) {
        window.location.href = storeUrl;
      }
    }, 1500);
  };

  return (
    <div className="fixed left-0 right-0 top-0 z-[9998] flex items-center gap-3 bg-m-surface border-b border-m-divider px-3 py-2.5 shadow-lg">
      {/* App icon */}
      <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-blue-600 text-white text-lg font-bold">
        M
      </div>

      {/* Text */}
      <div className="flex-1 min-w-0">
        <div className="text-sm font-medium text-m-text truncate">
          Meridian Chat
        </div>
        <div className="text-xs text-m-text-hint truncate">
          Откройте в приложении
        </div>
      </div>

      {/* Open button */}
      <button
        onClick={openApp}
        className="shrink-0 rounded-md bg-blue-600 px-4 py-1.5 text-sm font-medium text-white active:bg-blue-700"
      >
        Открыть
      </button>

      {/* Dismiss */}
      <button
        onClick={dismiss}
        className="shrink-0 flex items-center justify-center w-7 h-7 rounded-full text-m-text-hint hover:text-m-text active:bg-m-surface-light"
        aria-label="Закрыть"
      >
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        >
          <path d="M1 1l12 12M13 1L1 13" />
        </svg>
      </button>
    </div>
  );
}
